<div class="bg-gray-50 min-h-screen flex flex-col lg:flex-row">
  <ng-container *ngIf="!isMobileView; else mobileMenu">
    <aside
      class="w-full lg:w-72 bg-white/80 backdrop-blur-lg shadow-xl lg:min-h-screen p-6 border-r border-gray-200"
    >
      <div class="flex justify-center items-center mb-6">
        <img src="assets/images/cat_logo.png" alt="Caribbean Auto Terminal" />
      </div>
      <nav>
        <ul class="space-y-3">
          <li>
            <a
              routerLink="/dashboard"
              routerLinkActive="active"
              class="flex items-center gap-3 text-gray-700 hover:text-white hover:bg-red-500 transition-all duration-300 rounded-lg p-3 border border-transparent hover:border-red-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g fill="none" stroke="currentColor" stroke-width="1.5">
                  <path
                    stroke-linecap="round"
                    d="M22 22H2m0-11l4.063-3.25M22 11l-8.126-6.5a3 3 0 0 0-3.748 0l-.782.625M15.5 5.5v-2A.5.5 0 0 1 16 3h2.5a.5.5 0 0 1 .5.5v5M4 22V9.5m16 0v4m0 8.5v-4.5"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M15 22v-5c0-1.414 0-2.121-.44-2.56C14.122 14 13.415 14 12 14s-2.121 0-2.56.44M9 22v-5"
                  />
                  <path d="M14 9.5a2 2 0 1 1-4 0a2 2 0 0 1 4 0Z" />
                </g>
              </svg>
              <span class="font-medium">Dashboard</span>
            </a>
          </li>
          <li>
            <a
              routerLink="/vehicles"
              routerLinkActive="active"
              class="flex items-center gap-3 text-gray-700 hover:text-white hover:bg-red-500 transition-all duration-300 rounded-lg p-3 border border-transparent hover:border-red-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  color="currentColor"
                >
                  <path
                    d="m2.5 12l2 1m17-.5l-2 .5M8 17.5l.246-.614c.365-.913.548-1.37.929-1.628c.38-.258.872-.258 1.856-.258h1.938c.984 0 1.476 0 1.856.258s.564.715.93 1.628L16 17.5M2 17v2.882c0 .379.24.725.622.894c.247.11.483.224.769.224h1.718c.286 0 .522-.114.77-.224c.38-.169.621-.515.621-.894V18m11 0v1.882c0 .379.24.725.622.894c.247.11.483.224.769.224h1.718c.286 0 .522-.114.77-.224c.38-.169.621-.515.621-.894V17m-2-8.5l1-.5M4 8.5L3 8m1.5 1l1.088-3.265c.44-1.32.66-1.98 1.184-2.357S7.992 3 9.383 3h5.234c1.391 0 2.087 0 2.61.378c.525.377.745 1.037 1.185 2.357L19.5 9"
                  />
                </g>
              </svg>
              <span class="font-medium">Vehicles</span>
            </a>
          </li>
          <!-- <li>
            <a
              routerLink="/authorizes"
              routerLinkActive="active"
              class="flex items-center gap-3 text-gray-700 hover:text-white hover:bg-red-500 transition-all duration-300 rounded-lg p-3 border border-transparent hover:border-red-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M9 1.25a4.75 4.75 0 1 0 0 9.5a4.75 4.75 0 0 0 0-9.5M5.75 6a3.25 3.25 0 1 1 6.5 0a3.25 3.25 0 0 1-6.5 0"
                  clip-rule="evenodd"
                />
                <path
                  fill="currentColor"
                  d="M15 2.25a.75.75 0 0 0 0 1.5a2.25 2.25 0 0 1 0 4.5a.75.75 0 0 0 0 1.5a3.75 3.75 0 1 0 0-7.5"
                />
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M3.678 13.52c1.4-.8 3.283-1.27 5.322-1.27s3.922.47 5.322 1.27c1.378.788 2.428 1.99 2.428 3.48s-1.05 2.692-2.428 3.48c-1.4.8-3.283 1.27-5.322 1.27s-3.922-.47-5.322-1.27C2.3 19.692 1.25 18.49 1.25 17s1.05-2.692 2.428-3.48m.744 1.303C3.267 15.483 2.75 16.28 2.75 17s.517 1.517 1.672 2.177C5.556 19.825 7.173 20.25 9 20.25s3.444-.425 4.578-1.073c1.155-.66 1.672-1.458 1.672-2.177s-.517-1.517-1.672-2.177C12.444 14.175 10.827 13.75 9 13.75s-3.444.425-4.578 1.073"
                  clip-rule="evenodd"
                />
                <path
                  fill="currentColor"
                  d="M18.16 13.267a.75.75 0 0 0-.32 1.466c.792.173 1.425.472 1.843.814s.567.677.567.953c0 .25-.12.545-.453.854c-.335.311-.85.598-1.513.798a.75.75 0 1 0 .432 1.437c.823-.248 1.558-.631 2.102-1.136c.546-.507.932-1.174.932-1.953c0-.865-.474-1.588-1.117-2.114c-.644-.527-1.51-.908-2.472-1.119"
                />
              </svg>
              <span class="font-medium">Authorizes</span>
            </a>
          </li> -->
          <!-- <li>
            <a
              routerLink="/calculator"
              routerLinkActive="active"
              class="flex items-center gap-3 text-gray-700 hover:text-white hover:bg-red-500 transition-all duration-300 rounded-lg p-3 border border-transparent hover:border-red-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  fill-rule="evenodd"
                  d="M11.938 1.25h.124c2.069 0 3.706 0 4.987.191c1.323.198 2.373.614 3.19 1.522c.807.896 1.168 2.03 1.34 3.46c.171 1.407.171 3.212.171 5.525v.104c0 2.313 0 4.118-.17 5.525c-.173 1.43-.534 2.564-1.34 3.46c-.818.908-1.867 1.324-3.191 1.522c-1.281.191-2.918.191-4.986.191h-.126c-2.068 0-3.705 0-4.986-.191c-1.324-.198-2.373-.614-3.19-1.522c-.807-.896-1.168-2.03-1.34-3.46c-.171-1.407-.171-3.212-.171-5.525v-.104c0-2.313 0-4.118.17-5.524c.173-1.432.534-2.565 1.34-3.461c.818-.908 1.867-1.324 3.191-1.522c1.281-.191 2.918-.191 4.987-.191M7.173 2.925c-1.127.168-1.797.485-2.298 1.041c-.51.568-.81 1.346-.966 2.638C3.751 7.91 3.75 9.624 3.75 12s.001 4.09.16 5.396c.156 1.292.454 2.07.965 2.638c.501.556 1.171.873 2.298 1.041c1.157.173 2.682.175 4.827.175s3.67-.002 4.827-.175c1.127-.168 1.797-.485 2.297-1.041c.512-.568.81-1.346.967-2.638c.158-1.306.159-3.02.159-5.396s-.001-4.09-.16-5.396c-.156-1.292-.454-2.07-.965-2.638c-.501-.556-1.171-.873-2.298-1.041C15.67 2.752 14.145 2.75 12 2.75s-3.67.002-4.827.175M8.916 5.25h6.168c.38 0 .71 0 .998.077a2.25 2.25 0 0 1 1.591 1.59c.078.29.078.618.077 1v.167c0 .38 0 .71-.077.998a2.25 2.25 0 0 1-1.59 1.591c-.29.078-.618.078-1 .077H8.917c-.38 0-.71 0-.998-.077a2.25 2.25 0 0 1-1.591-1.59c-.078-.29-.077-.618-.077-1v-.167c0-.38 0-.71.077-.998a2.25 2.25 0 0 1 1.59-1.591c.29-.078.618-.077 1-.077M9 6.75c-.513 0-.623.006-.694.026a.75.75 0 0 0-.53.53c-.02.071-.026.18-.026.694c0 .513.006.623.026.694a.75.75 0 0 0 .53.53c.071.02.18.026.694.026h6c.513 0 .623-.006.694-.026a.75.75 0 0 0 .53-.53c.02-.071.026-.18.026-.694c0-.513-.006-.623-.026-.694a.75.75 0 0 0-.53-.53c-.071-.02-.18-.026-.694-.026z"
                  clip-rule="evenodd"
                />
                <path
                  fill="currentColor"
                  d="M9 13a1 1 0 1 1-2 0a1 1 0 0 1 2 0m0 4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m4-4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m0 4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m4-4a1 1 0 1 1-2 0a1 1 0 0 1 2 0m0 4a1 1 0 1 1-2 0a1 1 0 0 1 2 0"
                />
              </svg>
              <span class="font-medium">Storage Calculator</span>
            </a>
          </li> -->

          <li>
            <a
              routerLink="/vessel-schedule"
              routerLinkActive="active"
              class="flex items-center gap-3 text-gray-700 hover:text-white hover:bg-red-500 transition-all duration-300 rounded-lg p-3 border border-transparent hover:border-red-600"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                  d="m4.8 17.194l-.597-3.343a2 2 0 0 1 1.326-2.246l.17-.058m0 0l5.659-1.92a2 2 0 0 1 1.284 0l5.658 1.92m-12.6 0v-3.8a2 2 0 0 1 2-2h2.5m8.1 5.8l.17.058a2 2 0 0 1 1.327 2.246l-.597 3.342m-.9-5.646v-3.8a2 2 0 0 0-2-2h-2.5m-3.6 0h3.6m-3.6 0V4.8a1.8 1.8 0 0 1 3.6 0v.947M3 20.399c.647.657 2.222.843 3.725.216c1.032-.43 2.336-.441 3.391-.071a5.83 5.83 0 0 0 3.768 0c1.055-.37 2.359-.36 3.39.07c1.504.628 3.08.442 3.726-.216"
                />
              </svg>
              <span class="font-medium">Vessel Schedule</span>
            </a>
          </li>
        </ul>
      </nav>
    </aside>
  </ng-container>
  <ng-template #mobileMenu>
    <div class="flex-1 p-4 lg:p-8 flex flex-col">
      <div class="flex justify-between items-center w-full">
        <div class="flex justify-center items-center w-28">
          <img src="assets/images/cat_logo.png" alt="Caribbean Auto Terminal" />
        </div>
        <div class="flex items-center space-x-4">
          <a
            routerLink="/dashboard"
            routerLinkActive="active"
            class="flex items-center gap-3 text-gray-700 hover:text-white hover:bg-red-500 transition-all duration-300 rounded-lg p-3 border border-transparent hover:border-red-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g fill="none" stroke="currentColor" stroke-width="1.5">
                <path
                  stroke-linecap="round"
                  d="M22 22H2m0-11l4.063-3.25M22 11l-8.126-6.5a3 3 0 0 0-3.748 0l-.782.625M15.5 5.5v-2A.5.5 0 0 1 16 3h2.5a.5.5 0 0 1 .5.5v5M4 22V9.5m16 0v4m0 8.5v-4.5"
                />
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15 22v-5c0-1.414 0-2.121-.44-2.56C14.122 14 13.415 14 12 14s-2.121 0-2.56.44M9 22v-5"
                />
                <path d="M14 9.5a2 2 0 1 1-4 0a2 2 0 0 1 4 0Z" />
              </g>
            </svg>
          </a>
          <a
            routerLink="/vehicles"
            routerLinkActive="active"
            class="flex items-center text-gray-700 hover:text-white hover:bg-red-500 transition-all duration-300 rounded-lg p-3 border border-transparent hover:border-red-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                color="currentColor"
              >
                <path
                  d="m2.5 12l2 1m17-.5l-2 .5M8 17.5l.246-.614c.365-.913.548-1.37.929-1.628c.38-.258.872-.258 1.856-.258h1.938c.984 0 1.476 0 1.856.258s.564.715.93 1.628L16 17.5M2 17v2.882c0 .379.24.725.622.894c.247.11.483.224.769.224h1.718c.286 0 .522-.114.77-.224c.38-.169.621-.515.621-.894V18m11 0v1.882c0 .379.24.725.622.894c.247.11.483.224.769.224h1.718c.286 0 .522-.114.77-.224c.38-.169.621-.515.621-.894V17m-2-8.5l1-.5M4 8.5L3 8m1.5 1l1.088-3.265c.44-1.32.66-1.98 1.184-2.357S7.992 3 9.383 3h5.234c1.391 0 2.087 0 2.61.378c.525.377.745 1.037 1.185 2.357L19.5 9"
                />
              </g>
            </svg>
          </a>
          <a
            routerLink="/vessel-schedule"
            routerLinkActive="active"
            class="flex items-center text-gray-700 hover:text-white hover:bg-red-500 transition-all duration-300 rounded-lg p-3 border border-transparent hover:border-red-600"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="m4.8 17.194l-.597-3.343a2 2 0 0 1 1.326-2.246l.17-.058m0 0l5.659-1.92a2 2 0 0 1 1.284 0l5.658 1.92m-12.6 0v-3.8a2 2 0 0 1 2-2h2.5m8.1 5.8l.17.058a2 2 0 0 1 1.327 2.246l-.597 3.342m-.9-5.646v-3.8a2 2 0 0 0-2-2h-2.5m-3.6 0h3.6m-3.6 0V4.8a1.8 1.8 0 0 1 3.6 0v.947M3 20.399c.647.657 2.222.843 3.725.216c1.032-.43 2.336-.441 3.391-.071a5.83 5.83 0 0 0 3.768 0c1.055-.37 2.359-.36 3.39.07c1.504.628 3.08.442 3.726-.216"
              />
            </svg>
          </a>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="flex-1 p-4 lg:p-8 flex flex-col">
    <header
      class="flex justify-between items-center lg:mb-8 mb-4 bg-white p-5 rounded-lg shadow-md"
    >
      <h1 class="text-xl lg:text-2xl font-bold text-gray-800">
        Welcome back, {{ consigneeName }}
      </h1>
      <div class="flex items-center space-x-4">
        <button
          class="text-gray-600 hover:text-red-600 transition-all"
          (click)="openProfile()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="12" cy="12" r="3" />
              <path
                stroke-linecap="round"
                d="M3.661 10.64c.473.296.777.802.777 1.36s-.304 1.064-.777 1.36c-.321.203-.529.364-.676.556a2 2 0 0 0-.396 1.479c.052.394.285.798.75 1.605c.467.807.7 1.21 1.015 1.453a2 2 0 0 0 1.479.396c.24-.032.483-.13.819-.308a1.62 1.62 0 0 1 1.567.008c.483.28.77.795.79 1.353c.014.38.05.64.143.863a2 2 0 0 0 1.083 1.083C10.602 22 11.068 22 12 22s1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083c.092-.223.129-.483.143-.863c.02-.558.307-1.074.79-1.353a1.62 1.62 0 0 1 1.567-.008c.336.178.58.276.82.308a2 2 0 0 0 1.478-.396c.315-.242.548-.646 1.014-1.453c.208-.36.369-.639.489-.873m-.81-2.766a1.62 1.62 0 0 1-.777-1.36c0-.559.304-1.065.777-1.362c.321-.202.528-.363.676-.555a2 2 0 0 0 .396-1.479c-.052-.394-.285-.798-.75-1.605c-.467-.807-.7-1.21-1.015-1.453a2 2 0 0 0-1.479-.396c-.24.032-.483.13-.82.308a1.62 1.62 0 0 1-1.566-.008a1.62 1.62 0 0 1-.79-1.353c-.014-.38-.05-.64-.143-.863a2 2 0 0 0-1.083-1.083C13.398 2 12.932 2 12 2s-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083c-.092.223-.129.483-.143.863a1.62 1.62 0 0 1-.79 1.353a1.62 1.62 0 0 1-1.567.008c-.336-.178-.58-.276-.82-.308a2 2 0 0 0-1.478.396C4.04 5.79 3.806 6.193 3.34 7c-.208.36-.369.639-.489.873"
              />
            </g>
          </svg>
        </button>
        <button
          class="text-gray-600 hover:text-red-600 transition-all"
          (click)="logout()"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <g
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-width="1.5"
            >
              <path
                stroke-linejoin="round"
                d="M2.001 11.999h14m0 0l-3.5-3m3.5 3l-3.5 3"
              />
              <path
                d="M9.002 7c.012-2.175.109-3.353.877-4.121C10.758 2 12.172 2 15 2h1c2.829 0 4.243 0 5.122.879C22 3.757 22 5.172 22 8v8c0 2.828 0 4.243-.878 5.121c-.769.769-1.947.865-4.122.877M9.002 17c.012 2.175.109 3.353.877 4.121c.641.642 1.568.815 3.121.862"
              />
            </g>
          </svg>
        </button>
      </div>
    </header>

    <div class="flex flex-col">
      <div>
        <router-outlet></router-outlet>
      </div>

      <div>
        <footer class="py-4 w-full text-center text-gray-600">
          <p>
            &copy; {{ getYear() }} Caribbean Auto Terminal. All rights reserved.
          </p>
        </footer>
      </div>
    </div>
  </div>
</div>
